// 2018 is the only UK survey fielded as two separate samples; its data lives under
// general-population/ and practising-christians/. 2026 onward is a single unified dataset
// at the locale root, like US and Canada.
export const UK_SPLIT_YEARS = ["2018"];

export const isUKSplitYear = (year) => UK_SPLIT_YEARS.includes(year);

export const isUKUnifiedYear = (locale, year) =>
  locale === "uk" && !isUKSplitYear(year);

const DEFAULT_CATEGORY = "general-population";

// The route is /uk/data-explorer/:category?/:year?/:id?, so a URL naming only a year binds it
// to :category. Shift the params back into place; split years need a category, unified years
// must not have one or the data path gains a subdirectory that doesn't exist.
export const resolveUKRoute = (params, defaultYear) => {
  let { category, year, id } = params;

  if (/^\d{4}$/.test(category || "")) {
    id = year;
    year = category;
    category = undefined;
  }

  const resolvedYear = year || defaultYear;

  return {
    year: resolvedYear,
    id: id || 1,
    category: isUKSplitYear(resolvedYear) ? category || DEFAULT_CATEGORY : null,
  };
};
